import { loadScript } from './load-script';

export function getPeer39(config) {
  return new Promise((resolve) => {
    if (!config.peer39 || !config.peer39.url || !config.peer39.id) {
      resolve();
      return;
    }

    window[`afterFinished_${config.peer39.id}`] = () => {
      config.targeting.p39_sky = window.p39_GPT_value();
      resolve();
    };

    loadScript(config.peer39.url);

    // resolve and return nothing if peer-39 doesnt load in time
    setTimeout(resolve, Number(config.peer39.timeout));
  });
}
